import TinyQueue from 'tinyqueue';
function compare(a, b) {
    return a.priority < b.priority ? -1 : a.priority > b.priority ? 1 : 0;
}
export var heap = new TinyQueue([], function (a, b) { return compare(a, b); });
//# sourceMappingURL=Heap.js.map